import React, {useEffect, useRef, useState} from 'react';
import "./VideoViewer.sass"
import apiJSON from "../../../api/apiJSON";
import renderHTML from 'react-render-html';
import gsap from "gsap";
import CheckCircle from "../../../icons/check_circle.svg"
import Button from "../../ui/Button/Button";

const VideoViewer = ({data, completed, next}) => {

    const [selectedIndex, setSelectedIndex] = useState(-1);
    const [tracking, setTracking] = useState([]);
    const [finished, setFinished] = useState(false);
    const [playVideo, setPlayVideo] = useState(false);

    const jsonData = apiJSON.get(data);
    const scenario = jsonData.scenario;

    useEffect(() => {
        var mto = (selectedIndex == -1 ? 1 : 0);
        gsap.to(".video-viewer-main-text", {opacity: mto});
        if (selectedIndex != -1) {
            gsap.fromTo(".video-viewer-info-text", {opacity:0},{opacity: 1, delay: 0.3});
        }
        for (var i = 0; i < scenario.choiceSet.choices.length; i++) {
            var c = scenario.choiceSet.choices[i];
            if (i == selectedIndex) {
                gsap.to("#thumbnail" + i, {scale: 1.4, transformOrigin: "50% 50%", ease: "expo.out"})
            } else {
                gsap.to("#thumbnail" + i, {scale: 1, transformOrigin: "50% 50%", ease: "expo.out"})
            }
        }

    }, [selectedIndex]);

    const finish = () => {
        console.log("VideoViewer finish()");
        completed();
    }

    useEffect(() => {
        if (checkCompleted()) {
            finish();
        }
    }, [tracking]);

    useEffect(() => {
        if (!playVideo) {
            setSelectedIndex(-1);
            let t = tracking.slice();
            if (t.length == 0) {
                scenario.choiceSet.choices.map((index) => {
                    t.push(0)
                });
            } else {
                t[selectedIndex] = 1;
            }
            setTracking(t)
        } else {
            gsap.from(".video-viewer-player-overtitle", {x: -1600, ease: "expo.out", delay: 0.5})
        }
    }, [playVideo])

    const checkCompleted = () => {
        return (tracking.length>0&&tracking.indexOf(0) == -1);
    }

    const handleSelect = (event, index) => {
        console.log("handleSelect(" + index + ")");
        setSelectedIndex(index);
    }

    const handleOutsideClick = (event) => {
        setSelectedIndex(-1);
    }

    const toggleVideo = () => {
        setPlayVideo(!playVideo);
    }

    return (
        <div className="VideoViewer">
            {
                playVideo &&
                <div className="video-viewer-player-page">
                    <video src={scenario.choiceSet.choices[selectedIndex].video}
                           className="video-viewer-player"
                           autoPlay={true}
                           controls/>
                    <div className="video-viewer-player-overtitle">
                        {renderHTML(scenario.choiceSet.choices[selectedIndex].title)}
                        <Button data={"Done"}
                                className="video-viewer-done-button"
                                callback={toggleVideo}
                                style={{

                                    "margin-left": "100px"
                                }}/>
                    </div>

                </div>
            }
            {
                (selectedIndex != -1) &&
                <div className="video-viewer-info-text">
                    <div className="video-viewer-info-title">
                        {renderHTML(scenario.choiceSet.choices[selectedIndex].title)}
                    </div>
                    <div className="video-viewer-info-divider"/>
                    <div className="video-viewer-info-body">
                        {renderHTML(scenario.choiceSet.choices[selectedIndex].body)}
                    </div>
                    <Button data={"Watch Video"}
                            style={{"margin": "auto"}}
                            callback={toggleVideo}/>
                </div>
            }
            {
                scenario &&
                <div className="video-viewer-main-text">
                    <div className="video-viewer-main-title">
                        {scenario.title}
                    </div>
                    <div className="video-viewer-main-divider"/>
                    <div className="video-viewer-main-body">
                        {renderHTML(scenario.body)}
                    </div>
                </div>
            }
            <div className="click-catcher"
                 onClick={handleOutsideClick}/>
            {
                scenario &&
                <div className="video-viewer-row">
                    {scenario.choiceSet.choices.map((choice, index) => (
                        <div className="video-viewer-item">
                            <div className={"video-viewer-thumbnail-holder" + ((selectedIndex!==-1&&index!==selectedIndex)?" disabled":"")}
                                 id={"thumbnail" + index}
                                 onClick={(event) => {
                                     handleSelect(event, index)
                                 }}>
                                <div className="video-viewer-thumbnail"
                                     key={"choice" + index}>
                                    <img src={choice.image}/>
                                </div>
                                <div className={"video-viewer-check" + (tracking[index] == 0 ? " invisible" : "")}>
                                    <img src={CheckCircle}/>
                                </div>
                            </div>
                            <div className={"video-viewer-label"+ ((selectedIndex!==-1)?" disabled":"")}
                                 id={"label" + index}>
                                {renderHTML(choice.label)}
                            </div>
                        </div>
                    ))}
                </div>
            }
        </div>
    );
}
;

export default VideoViewer;